import { mapGetters } from 'vuex';

export const menu_items_mixin = {
    data() {
        return {
            items: [
                {
                    path: `/`,
                    icon: "mdi-home-outline",
                    text: "Inicio",
                    user: [1, 3, 6, 5, 7, 8, 16],
                },
                {
                    path: `/lista-chats`,
                    icon: "mdi-chat",
                    text: "Chats",
                    user: [1, 3, 6, 5, 7, 8,10, 12, 16],
                },
                {
                    path: `/lista-mensajes-pendientes`,
                    icon: "mdi-chat-processing",
                    text: "Chat Aprobar",
                    user: [1,  6, 5, 7, 12],
                },
                {
                    path: `/lista-potenciales`,
                    icon: "mdi-file-powerpoint",
                    text: "Potenciales",
                    user: [1, 5, 7, 6, 8, 9,11],
                },
                {
                    path: '',
                    icon: "mdi-calendar",
                    text: "Seguimientos",
                    user: [1, 5, 8, 9,11, 12],
                    hijo: true,
                    children: [
                        {
                            path: `/calendario-seguimiento`,
                            icon: "mdi-account-clock-outline",
                            text: "Seguimiento Potenciales",
                            user: [1, 5, 8, 9,11],
                        },
                        {
                            path: `/calendario-seguimiento-cliente`,
                            icon: "mdi-account-clock",
                            text: "Seguimiento Clientes",
                            user: [1, 5, 8, 9,11],
                        },
                        {
                            path: `/calendario-seguimiento-gestion`,
                            icon: "mdi-account-clock",
                            text: "Seguimiento Gestión",
                            user: [1, 12],
                        },
                        {
                            path: `/informe-llamadas`,
                            icon: "mdi-file-clock",
                            text: "Informe de llamdas",
                            user: [1, 5, 8, 9],
                        },
                    ],

                },
                {
                path: `/lista-dominio`,
                    icon: "mdi-web",
                    text: "Dominios",
                    user: [1, 5, 8, 9],
                },
                {
                    path: ``,
                    icon: "mdi-account-tie",
                    text: "Clientes",
                    user: [1, 5, 6, 7, 8, 9, 11, 12],
                    hijo: true,
                    children: [
                        {
                            path: `/lista-clientes`,
                            icon: "mdi-account-tie",
                            text: "Clientes",
                            user: [1, 5, 6, 7, 8, 9,11, 12],
                        },
                        {
                            path: `/lista-proyectos-cliente`,
                            icon: "mdi-file-cabinet",
                            text: "Proyectos",
                            user: [1, 5, 6, 7, 8, 12],
                        },
                        {
                            path: `/gestion-proyectos`,
                            icon: "mdi-file-cabinet",
                            text: "Gestión Proyectos",
                            user: [1, 5, 12],
                        },
                        {
                            path: `/consumo-proyecto`,
                            icon: "mdi-clock",
                            text: "Consumo Proyecto",
                            user: [1, 12],
                        },
                    ],
                },
                {
                    path: `/calendario-reuniones`,
                    icon: "mdi-clock",
                    text: "Reuniones",
                    user: [1, 6, 5, 7, 8, 9, 12],
                },
                {
                    path: `/lista-producto`,
                    icon: "mdi-shape-plus",
                    text: "Productos",
                    user: [1, 5,6, 7, 8, 9, 12],
                },
                {
                    path: `/lista-protocolos`,
                    icon: "mdi-protocol",
                    text: "Protocolos",
                    user: [1, 5, 6, 7, 8, 9, 12],
                },
                {
                    path: `/archivos`,
                    icon: "mdi-clipboard-file",
                    text: "Archivos",
                    user: [1, 5, 6, 7, 8, 9, 12],
                },
                {
                    path: `/tickets`,
                    icon: "mdi-ticket-account",
                    text: "Tickets",
                    user: [1, 3, 5, 6, 7, 8, 9, 10, 12, 16],
                },
                {
                    path: `/lista-clientes-crm`,
                    icon: "mdi-chart-box-outline",
                    text: "Contenido CRM",
                    user: [1,5, 12],
                },
                {
                    path: `/tareas`,
                    icon: "mdi-file-tree",
                    text: "Tareas",
                    user: [1, 3,5, 6, 7,10, 12, 16],
                },
                {
                    path: `/lista-plantilla`,
                    icon: "mdi-whatsapp",
                    text: "Plantillas",
                    user: [1, 5, 8],
                },
                {
                    path: ``,
                    icon: "mdi-account-tie-outline",
                    text: "Administración",
                    user: [1, 3, 5, 6, 7, 8, 9, 12, 15],
                    hijo: true,
                    children: [
                        {
                            path: `/lista-gastos`,
                            icon: "mdi-calculator-variant",
                            text: "Gastos",
                            user: [1],
                        },
                        {
                            path: `/lista-facturas`,
                            icon: "mdi-file-table-outline",
                            text: "Facturas",
                            user: [1, 5, 7,9, 15],
                        },
                        {
                            path: `/lista-facturas-pro`,
                            icon: "mdi-file-table-outline",
                            text: "Facturas Proforma",
                            user: [1, 5, 7,9],
                        },
                        {
                            path: `/lista-facturas-devolucion`,
                            icon: "mdi-file-table-outline",
                            text: "Abonos",
                            user: [1, 5, 7,9],
                        },
                        {
                            path: `/lista-facturas-pendientes`,
                            icon: "mdi-file-hidden",
                            text: "Clientes a Facturar",
                            user: [1, 5, 7,9],
                        },
                        {
                            path: `/lista-ingresos`,
                            icon: "mdi-calculator-variant",
                            text: "Ingresos",
                            user: [1, 5],
                        },

                        {
                            path: `/lista-fichajes`,
                            icon: "mdi-card-account-details-outline",
                            text: "Fichajes",
                            user: [1, 3, 5, 6, 7, 8, 9,10, 12],
                        },
                        {
                            path: "/calendario-vacaciones",
                            icon: "mdi-calendar-clock",
                            text: "Vacaciones",
                            user: [1, 3, 5, 6, 7, 8, 9,10, 12],
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-billboard",
                    text: "Marketing",
                    user: [1, 5, 6, 7,10],
                    hijo: true,
                    children: [
                        {
                            path: `/lista-promociones`,
                            icon: "mdi-bullhorn",
                            text: "Promociones",
                            user: [1, 7],
                        },
                        {
                            path: `/lista-clientes-social`,
                            icon: "mdi-instagram",
                            text: "Contenido Redes",
                            user: [1, 6, 7,10],
                        },
                        {
                            path: `/lista-paginas-facebook`,
                            icon: "mdi-facebook",
                            text: "Campañas Facebook",
                            user: [1, 5, 6, 7],
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-controller-classic",
                    text: "Cuadro de Mando",
                    user: [1, 3, 5, 6, 7, 8,9,11, 12, 13, 14],
                    hijo: true,
                    children: [
                        {
                            path: ``,
                            icon: "mdi-teach",
                            text: "TFG",
                            user: [1, 3, 5, 6, 7, 8,9, 13],
                            user_tfg: [1, 2, 3, 5, 6, 4, 7],
                            hijo: true,
                            children: [
                                {
                                    path: `/lista-gastos-tfg`,
                                    icon: "mdi-cash",
                                    text: "Gastos",
                                    user: [1, 3, 5, 6, 7],
                                    user_tfg: [1],
                                },
                                {
                                    path: `/lista-potenciales-tfg`,
                                    icon: "mdi-account-alert",
                                    text: "Potenciales",
                                    user: [1, 3, 5, 7, 8, 9, 13],
                                    user_tfg: [1, 3, 2],
                                },

                                {
                                    path: `/lista-ventas-tfg`,
                                    icon: "mdi-point-of-sale",
                                    text: "Ventas Diarias",
                                    user: [1, 3, 5, 6, 7, 8],
                                    user_tfg: [5, 1, 4],
                                },
                                /*{
                                    path: `/lista-ventas-resumen-tfg`,
                                    icon: "mdi-chart-arc",
                                    text: "Ventas Resumen",
                                    user: [1, 3,6],
                                    user_tfg: [1],
                                },*/
                                {
                                    path: `/lista-marketing-tfg`,
                                    icon: "mdi-chart-arc",
                                    text: "Marketing",
                                    user: [1, 3, 5, 6, 7],
                                    user_tfg: [1, 3, 6],
                                },
                            ],
                        },
                        {
                            path: ``,
                            icon: "mdi-domain",
                            text: "FIDIAS",
                            user: [1, 5, 6, 7, 8,9,11, 12, 14],

                            hijo: true,
                            children: [
                                {
                                    path: `/lista-ventas`,
                                    icon: "mdi-point-of-sale",
                                    text: "Ventas Diarias",
                                    user: [1, 5, 8,9],
                                },
                                /*{
                                    path: `/lista-ventas-resumen`,
                                    icon: "mdi-podium-gold",
                                    text: "Resumen Ventas Diarias",
                                    user: [1],
                                },*/
                                {
                                    path: `/lista-ventas-kit`,
                                    icon: "mdi-point-of-sale",
                                    text: "Ventas Kit",
                                    user: [1, 5, 6, 7, 8,9, 11, 12, 14],
                                },
                                {
                                    path: `/lista-ventas-yotico`,
                                    icon: "mdi-checkbox-marked-circle-outline",
                                    text: "Ventas Yotico",
                                    user: [1, 5, 7, 8, 9, 12, 14],
                                },
                                {
                                    path: `/lista-seguimiento-campana`,
                                    icon: "mdi-clock",
                                    text: "SVD",
                                    user: [1, 6, 7],
                                },
                                {
                                    path: `/lista-marketing`,
                                    icon: "mdi-chart-arc",
                                    text: "Marketing",
                                    user: [1, 5, 6, 7],
                                },
                            ],
                        },
                        {
                            path: ``,
                            icon: "mdi-teach",
                            text: "TFG Alicante",
                            user: [1, 3, 5, 6, 7, 8],
                            user_tfg: [1, 2, 3, 5, 6, 4, 7],

                            hijo: true,
                            children: [
                                {
                                    path: `/lista-gastos-tfg-alicante`,
                                    icon: "mdi-cash",
                                    text: "Gastos",
                                    user: [1, 3, 5, 6, 7],
                                    user_tfg: [1],
                                },

                                {
                                    path: `/lista-ventas-tfg-alicante`,
                                    icon: "mdi-point-of-sale",
                                    text: "Ventas Diarias",
                                    user: [1, 3, 5, 6, 7, 8],
                                    user_tfg: [5, 1, 4],
                                },

                                {
                                    path: `/lista-marketing-tfg-alicante`,
                                    icon: "mdi-chart-arc",
                                    text: "Marketing",
                                    user: [1, 3, 5, 6, 7],
                                    user_tfg: [1, 3, 6],
                                },
                            ],
                        },
                        {
                            path: "/estadisticas",
                            icon: "mdi-chart-line-stacked",
                            text: "Estadísticas",
                            user: [1],
                        },
                    ],
                },
                {
                    path: ``,
                    icon: "mdi-office-building",
                    text: "Empresa",
                    user: [1, 5, 7],
                    hijo: true,
                    children: [
                        {
                            path: "/lista-empresas",
                            icon: "mdi-office-building-outline",
                            text: "Empresas",
                            user: [1],
                        },
                        {
                            path: "/lista-usuario",
                            icon: "mdi-account-supervisor-circle",
                            text: "Usuarios",
                            user: [1, 7],
                        },
                        {
                            path: "/lista-colaboradores",
                            icon: "mdi-account-group-outline",
                            text: "Colaboradores",
                            user: [1, 7],
                        },
                        {
                            path: `/lista-passwords`,
                            icon: "mdi-form-textbox-password",
                            text: "Contraseñas",
                            user: [1, 5],
                        },
                    ],
                },
            ],
        };
    },

    computed: {
        ...mapGetters({
            userRole: 'auth/userRole',
            userData: 'auth/userData',
            userDataTemp: 'auth/userDataTemp',
            hasPermission: 'auth/hasPermission'
        }),
        computedheaders: function () {
            const modulos_permitidos = this.userDataTemp.permissions;
            
            // if (this.userRole != 0) {
            if (this.userDataTemp.role != 0) {
                const self = this;
                function filter(x) {
                    const tieneRol = x.user.some(
                        // (userole) => userole == self.userRole
                        (userole) => userole == self.userDataTemp.role
                    );
   

                    const tienePermiso = modulos_permitidos.includes(x.text);

                    // Si es un módulo con hijos, verificar si alguno de sus hijos tiene permiso
                    let tieneHijosPermitidos = false;
                    if (x.children && x.children.length > 0) {
                        tieneHijosPermitidos = x.children.some(child => 
                            modulos_permitidos.includes(child.text) || 
                            (child.children && child.children.some(subChild => 
                                modulos_permitidos.includes(subChild.text)
                            ))
                        );
                    }
                    
                    let condition = tieneRol || tienePermiso || tieneHijosPermitidos;
                    
                    // Verificación específica para reuniones
                    if (x.text === "Reuniones") {
                        if (self.userDataTemp.id == 6434) {
                            condition = true;
                        }
                    }

                    // Verificación específica para contraseñas
                    if (x.text === "Contraseñas") {
                        if (![40, 52, 1287].includes(parseInt(self.userDataTemp.id))) {
                            condition = false;
                        }
                    }
                    
                    // Verificación de rol_tfg
                    if (x.user_tfg != null) {
                        // Si es admin (role 1), permitir acceso sin rol_tfg
                        // if (self.userRole == 1) {
                        if (self.userDataTemp.role == 1) {
                            condition = condition && true;
                        } else {
                            // Si no tiene rol_tfg, no mostrar las opciones de TFG
                            if (!self.userDataTemp.rol_tfg) {
                                return false;
                            }
                            condition = condition && x.user_tfg.some(
                                (userole) => userole == self.userDataTemp.rol_tfg
                            );
                        }
                    }

                    return condition;
                }

                let filtrao = self.items.filter(filter);
                
                filtrao.forEach((element) => {
                    if (element.children != null) {
                        // Filtrar los hijos
                        element.children = element.children.filter(child => {
                            const tieneRolHijo = child.user.some(
                                // (userole) => userole == self.userRole
                                (userole) => userole == self.userDataTemp.role
                            );
                            const tienePermisoHijo = modulos_permitidos.includes(child.text);
                            
                            // Verificación de rol_tfg para hijos
                            if (child.user_tfg != null) {
                                // if (self.userRole == 1) {
                                if (self.userDataTemp.role == 1) {
                                    return true;
                                } else {
                                    if (!self.userDataTemp.rol_tfg) {
                                        return false;
                                    }
                                    return child.user_tfg.some(
                                        (userole) => userole == self.userDataTemp.rol_tfg
                                    );
                                }
                            }
                            
                            // Si el hijo tiene sus propios hijos, verificar si alguno tiene permiso
                            let tieneSubHijosPermitidos = false;
                            if (child.children && child.children.length > 0) {
                                tieneSubHijosPermitidos = child.children.some(subChild => 
                                    modulos_permitidos.includes(subChild.text)
                                );
                            }
                            
                            return tieneRolHijo || tienePermisoHijo || tieneSubHijosPermitidos;
                        });

                        // Procesar subhijos
                        element.children.forEach((child) => {
                            if (child.children != null) {
                                child.children = child.children.filter(subChild => {
                                    const tieneRolSubHijo = subChild.user.some(
                                        // (userole) => userole == self.userRole
                                        (userole) => userole == self.userDataTemp.role
                                    );
                                    const tienePermisoSubHijo = modulos_permitidos.includes(subChild.text);
                                    
                                    // Verificación de rol_tfg para subhijos
                                    if (subChild.user_tfg != null) {
                                        // if (self.userRole == 1) {
                                        if (self.userDataTemp.role == 1) {
                                            return true;
                                        } else {
                                            if (!self.userDataTemp.rol_tfg) {
                                                return false;
                                            }
                                            return subChild.user_tfg.some(
                                                (userole) => userole == self.userDataTemp.rol_tfg
                                            );
                                        }
                                    }
                                    
                                    return tieneRolSubHijo || tienePermisoSubHijo;
                                });
                            }
                        });

                        if (element.children.length == 1) {
                            element.path = element.children[0].path;
                            element.icon = element.children[0].icon;
                            element.text = element.children[0].text;
                            element.children = element.children[0].children;
                        }
                    }
                });

                return filtrao;
            }
        },

        modulos() {
            let modulosTexto = [];
            
            const agregarModulo = (elemento) => {
                // Si el elemento tiene path y no está vacío, es un módulo navegable
                if (elemento.path && elemento.path !== '') {
                    modulosTexto.push(elemento.text);
                }
                // Si tiene hijos, procesar cada hijo
                if (elemento.children && elemento.children.length > 0) {
                    elemento.children.forEach(child => {
                        agregarModulo(child);
                    });
                }
            };

            this.items.forEach(element => {
                agregarModulo(element);
            });

            return modulosTexto;
        }
    },
};
